import LoadingSpinner from '@/components/ui/loading'
import { useAuthContext } from '@/context'
import { useQueryMe } from '@/services/auth/queries'
import { ReactElement, ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

const PublicRouteWrapper = ({ component }: { component: ReactNode }): ReactElement => {
    const { loggedIn } = useAuthContext()
    const location = useLocation()
    const isAuthPage = ['/login', '/register', '/magic', '/forgot-password', '/reset-password'].some(path =>
        location.pathname.includes(path)
    )

    const { isLoading } = useQueryMe({ enabled: !isAuthPage })

    if (isLoading && !isAuthPage) {
        return <LoadingSpinner />
    }

    return !loggedIn ? <>{component}</> : <Navigate to='/dashboard/2hq' replace />
}

export default PublicRouteWrapper
